import styled from "styled-components";

export const LabelInputs = styled("span")`
  color: #000;
  font-weight: 500;
`;
